import { useNavigate } from "react-router-dom"
import BlueTableHeading from "../../../../common/AdminCommonComponents/BlueTableHeading/BlueTableHeading"
import ActionButton from "../../../../common/AdminCommonComponents/Buttons/ActionButton/ActionButton"
import GeneralBackButton from "../../../../common/AdminCommonComponents/Buttons/GeneralBackButton/GeneralBackButton"
import DynamicDatatable from "../../../../common/AdminCommonComponents/DynamicDatatable/DynamicDatatable"
import GrayDivider from "../../../../common/AdminCommonComponents/GrayDivider/GrayDivider"
import LightGrayBgWrapper from "../../../../common/AdminCommonComponents/LightGrayBgWrapper/LightGrayBgWrapper"
import StatusBadge from "../../../../common/AdminCommonComponents/StatusBadge/StatusBadge"

const SellerProductDetails = () => {


  const actions = [
    { label: 'View Details', action: () => console.log('') },
    { label: 'Edit', action: () => console.log('') },
    { label: 'Delete', action: () => console.log('') },
    { label: 'Change status ', action: () => console.log('') },
  ]

  const tableData = [
    { sr: '1', productId: '7534790', name: 'Mug', purchasePrice: '$6', sellingPrice: '$10', featured: '', status: 'Active' },
    { sr: '2', productId: '7534790', name: 'Mug', purchasePrice: '$6', sellingPrice: '$10', featured: '', status: 'Inactive' },
    { sr: '3', productId: '7534790', name: 'Mug', purchasePrice: '$6', sellingPrice: '$10', featured: '', status: 'Active' },
    { sr: '4', productId: '7534790', name: 'Mug', purchasePrice: '$6', sellingPrice: '$10', featured: '', status: 'Inactive' },
    { sr: '5', productId: '7534790', name: 'Mug', purchasePrice: '$6', sellingPrice: '$10', featured: '', status: 'Active' },
  ]

  const columns = [
    {
      name: 'SR #',
      selector: row => row.sr,
      sortable: true,
      grow: 0.5
    },
    {
      name: 'Product ID.',
      selector: row => row.productId,
      sortable: true,
    },
    {
      name: 'Name',
      selector: row => row.name,
      sortable: true,
    },
    {
      name: 'Purchase Price',
      selector: row => row.purchasePrice,
      sortable: true,
    },
    {
      name: 'Selling Price',
      selector: row => row.sellingPrice,
      sortable: true,
    },
    {
      name: 'Featured',
      selector: row => row.payment,
      sortable: true,
    },
    {
      name: 'Status',
      selector: row => <StatusBadge statusName={row.status}/>,
      sortable: true,
    },
    {
      name: 'Actions',
      cell: () => <ActionButton options={actions} />,
      center: "true",
      button: true
    }
  ];
  
  


  return (
    <LightGrayBgWrapper>
      <div className="p-3 shadow bg-white">
        <GeneralBackButton />

        <BlueTableHeading className='fw-semibold fs-5 mt-2'>Products List</BlueTableHeading>

        <div className="my-3"> 
          <GrayDivider />
        </div>

        <DynamicDatatable columns={columns} data={tableData} pagination type='gray' />
      </div>
    </LightGrayBgWrapper>
  )
}

export default SellerProductDetails
